import React, { useState } from 'react'
import PropTypes from 'prop-types'
import IconArrowDown from 'client/icons/ChevronDown'
import IconArrowUp from 'client/icons/ChevronUp'
import { CollapsibleSectionBase, Title, Content, Header, IconWrapper } from './styles'

const CollapsibleSection = ({
  title,
  children,
  iconToOpen,
  iconToClose,
  initialState = false,
  fullWidth = false,
}) => {
  const [showMore, setShowMore] = useState(initialState)
  const IconToOpen = iconToOpen || IconArrowDown
  const IconToClose = iconToClose || IconArrowUp

  return (
    <CollapsibleSectionBase fullWidth={fullWidth}>
      <Header onClick={() => setShowMore(!showMore)}>
        <Title>{title}</Title>
        <IconWrapper>
          {showMore ? (
            <IconToClose data-testid="collapsible-close-icon" />
          ) : (
            <IconToOpen data-testid="collapsible-open-icon" />
          )}
        </IconWrapper>
      </Header>

      {showMore && <Content data-testid="collapsible-content">{children}</Content>}
    </CollapsibleSectionBase>
  )
}

CollapsibleSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  initialState: PropTypes.bool,
  fullWidth: PropTypes.bool,
  iconToOpen: PropTypes.objectOf(PropTypes.any),
  iconToClose: PropTypes.objectOf(PropTypes.any),
}

export default CollapsibleSection
